import './NoticeBox.less';
import React from 'react';
import Icon from "../icon/Icon";


export default function NoticeBox(
    {
        children,
        message,
        type = NOTICE_INFO,
        size = 'medium' // large | medium | small
    }
) {
    const getIconName = () => {
        switch (type) {
            case NOTICE_SUCCESS: return 'tick';
            case NOTICE_ERROR: return 'caution-circle';
            case NOTICE_WARN: return'caution-circle';
            case NOTICE_INFO: return 'info-circle';
        }
    };

    const getTypeClass = () => {
        switch (type) {
            case NOTICE_SUCCESS: return 'notice-success';
            case NOTICE_ERROR: return 'notice-error';
            case NOTICE_WARN: return'notice-warn';
            case NOTICE_INFO: return 'notice-info';
        }
    };

    const getSizeClass = () => {
        switch (size) {
            case 'large': return 'size-large';
            case 'medium': return 'size-medium';
            case 'small': return'size-small';
        }
    }

    return <div className={`notice-box ${getTypeClass()} ${getSizeClass()}`}>
        <Icon name={getIconName()}/>
        <div className="message">
            {children || message}
        </div>
    </div>;
}


const NOTICE_SUCCESS = 'success';
const NOTICE_INFO = 'info';
const NOTICE_ERROR = 'error';
const NOTICE_WARN = 'warn';

export {
    NOTICE_SUCCESS,
    NOTICE_INFO,
    NOTICE_ERROR,
    NOTICE_WARN
};
